import SyncProblemRoundedIcon from '@mui/icons-material/SyncProblemRounded';
import { Alert, Button, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface VersionConflictAlertProps {
  onReload: () => void;
  reloading: boolean;
}

/**
 * "This conversation changed — reload" — the ONLY response to a `409 settings.version_conflict` on an
 * episode-versioned action (design §11.2, adr-merchant-portal-021 D1). Never auto-retries: the operator
 * must see the fresh state (a colleague may have already acted) before acting again.
 */
export function VersionConflictAlert({ onReload, reloading }: VersionConflictAlertProps) {
  const { t } = useTranslation('conversations');
  return (
    <Alert
      severity="warning"
      role="alert"
      icon={<SyncProblemRoundedIcon fontSize="inherit" />}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={onReload}
          disabled={reloading}
          aria-label={t('detail.conflict.reloadAria')}
          startIcon={reloading ? <CircularProgress size={14} color="inherit" /> : undefined}
        >
          {t('detail.conflict.reload')}
        </Button>
      }
    >
      {t('detail.conflict.message')}
    </Alert>
  );
}
